<template lang="pug">
.row.meeting-time(v-if="section.limitation_visible()")
    div(v-html="age_limit(section)")
    div(v-html="grade_limit(section)")
</template>
<script>
import base_mixins from "../../../code/base_mixins";
export default {
  mixins: [base_mixins],
  props: ['section'],
  methods: {
    age_limit(section) {
      let lowest_age = []
      if (this.isPresent(section.age_date_from_year))
        lowest_age.push( this.t('helpers.label.section.validation.number_years',{num: section.age_date_from_year}) )
      if (this.isPresent(section.age_date_from_month) && section.age_date_from_month > 0)
        lowest_age.push( this.t('helpers.label.section.validation.number_months', {num: section.age_date_from_month}) )

      let highest_age = []
      if (this.isPresent(section.age_date_until_year))
        highest_age.push( this.t('helpers.label.section.validation.number_years', {num: section.age_date_until_year}) )
      if (this.isPresent(section.age_date_until_month) && section.age_date_until_month > 0)
        highest_age.push( this.t('helpers.label.section.validation.number_months', {num: section.age_date_until_month}) )


      const separator = this.t('helpers.label.section.validation.separator_and');
      let result = []
      if (lowest_age.length > 0)
        result.push( this.t('helpers.label.section.validation.starting_at_age', {age: lowest_age.join(separator)}) );
      if (highest_age.length > 0)
        result.push( this.t('helpers.label.section.validation.up_to_age', {age: highest_age.join(separator)}) );
      if (result.length > 0) {
        return result.join('; ') + "<br>"
      }else {
        return "";
      }
    },
    grade_limit(section) {
      const result = []
      if (this.isPresent(section.grade_from))
        result.push(this.t('helpers.label.section.validation.minimum_grade', {num: section.grade_from}))
      if (this.isPresent(section.grade_until))
        result.push(this.t('helpers.label.section.validation.maximum_grade', {num: section.grade_until}))

      return result.join("; ")
    }
  }
}
</script>